import { getAppEnv } from '@/core/config/env'
import type { PersistedSession } from '@/core/auth/session/session.types'

function getStorageKey() {
  return getAppEnv().sessionStorageKey
}

export function persistSession(session: PersistedSession) {
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify(session))
  } catch {
    // Storage might be unavailable (private mode, quota exceeded). Ignore.
  }
}

export function loadPersistedSession(): PersistedSession | null {
  try {
    const raw = localStorage.getItem(getStorageKey())

    if (!raw) return null

    return JSON.parse(raw) as PersistedSession
  } catch {
    localStorage.removeItem(getStorageKey())
    return null
  }
}

export function clearPersistedSession() {
  try {
    localStorage.removeItem(getStorageKey())
  } catch {
    // Ignore
  }
}

export function getStoredToken(): string | null {
  try {
    const raw = localStorage.getItem(getStorageKey())
    if (!raw) return null
    const parsed = JSON.parse(raw) as PersistedSession
    return parsed.accessToken ?? null
  } catch {
    return null
  }
}
